import './blank.scss';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import AOS from 'aos';
import 'jquery-match-height';
import 'slick-carousel';
import { debounce } from 'lodash';
import Forms from './components/forms';
import Scroller from './components/scroller';

class App {
  static init() {
    AOS.init({
      disable: 'mobile'
    });

    (new Forms()).init();
    (new Scroller()).watch();

    $(window).on("scroll load", () => {
      const $navbar = $("nav.navbar.fixed-top")

      if ($(window).scrollTop() > $navbar.outerHeight() / 2) {
        $navbar.addClass("scrolled")
      } else {
        $navbar.removeClass("scrolled")
      }
    })

    $("#topNav")
      .on("hide.bs.collapse", () => {
        $(".navbar").removeClass("active")
      })
      .on("show.bs.collapse", () => {
        $(".navbar").addClass("active")
      })

    if ($('section.lead-form').length) {
      (async () => {
        const LeadForm = (await import('./components/lead-form-runner')).default;
        (new LeadForm()).init()
      })();
    }

    $('section.steps-carousel .slick-main')
      .on('init', () => {
        // window.aos.refresh();
      })
      .slick({
        arrows: true,
        dots: true,
        asNavFor: '.slick-images',
        appendDots: $('[slick-dots]'),
        nextArrow: $('[slick-next]'),
        prevArrow: $('[slick-prev]'),
      });

    $('section.steps-carousel .slick-images')
      .on('init', () => {
        // window.aos.refresh();
      })
      .slick({
        arrows: false,
        dots: false,
        asNavFor: '.slick-main'
      });

    $('section.featured-bar .slick-slider')
      .on('init', () => {
        // window.aos.refresh();
      })
      .slick({
        arrows: false,
        dots: false,
        autoplay: true,
        slidesToShow: 5,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              variableWidth: true,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              variableWidth: true,
            }
          }
        ]
      });

    $('section.testimonials .slick-slider')
      .on('init', () => {
        // window.aos.refresh();
      })
      .slick({
        arrows: false,
        dots: true,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });

    $('section.reviews-carousel .slick-slider')
      .on('init', () => {
        // window.aos.refresh();
      })
      .slick({
        arrows: false,
        dots: true,
        asNavFor: '.slick-main'
      });

    $(window).on('scroll', debounce(() => {
      const $bar = $('section.sticky-bar');
      const isOnBottom = $(document).scrollTop() + $(window).height() >= $(document).height() - $(window).height() / 2;
      const isOnTop = $(document).scrollTop() < $(window).height() / 2;
      $bar.toggleClass('hide', isOnBottom || isOnTop);
    }, 50));
  }
}

App.init();
